// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base, Text } from '@gandi/ui';

import { PriceArea } from '../DomainCreate/components/ProvidedArea/PriceArea';
import type { ExtendedSuggestion } from '../DomainCreate/types';

import { FqdnCell } from './FqdnCell';

import type { AvailabilityIconName } from './Icon/IconContainer';
import { ProvidedContainerLayout } from './ProvidedContainerLayout';

import styles from './ProvidedRowContainer.scss';

type Props = {
  addedToCart?: boolean,
  availabilityIconName: AvailabilityIconName,
  availabilityText: string | React.Node,
  beforePriceArea?: React.Node,
  cheapRenew?: boolean,
  children: React.Node,
  className?: string,
  corporate?: boolean,
  forceDisplayRestriction?: boolean,
  fqdn: string,
  id?: string,
  isCartActionnable?: boolean,
  isErrorWithRestriction?: boolean,
  loading: boolean,
  onClickItem: (evt: SyntheticMouseEvent<>) => any,
  premium?: ExtendedSuggestion['premium'],
  valid?: boolean,
};

export function ProvidedRowContainer({
  addedToCart = false,
  availabilityIconName,
  availabilityText,
  beforePriceArea,
  cheapRenew = false,
  children,
  className,
  corporate = false,
  forceDisplayRestriction,
  fqdn,
  id,
  isCartActionnable = false,
  isErrorWithRestriction = false,
  loading,
  onClickItem,
  premium = 0,
  valid = false,
}: Props): React.MixedElement {
  return (
    <ProvidedContainerLayout
      id={id}
      className={clsx(styles.root, className)}
      availabilityIconName={availabilityIconName}
      renderButton={
        <React.Fragment key={beforePriceArea ? 'with-lang' : 'without-lang'}>
          {beforePriceArea}
          <PriceArea
            onClick={onClickItem}
            isCartActionnable={isCartActionnable}
            addedToCart={addedToCart}
            loading={loading}
          >
            {children}
          </PriceArea>
        </React.Fragment>
      }
    >
      <>
        {typeof availabilityText === 'string' ? (
          <Text>{availabilityText}</Text>
        ) : (
          availabilityText
        )}
        {/* DomainProductDescription */}
        <Base
          flex
          size="bigger"
          weight="semibold"
          flexAlignItemsCenter
          flexWrap
          className={styles.domainProductDescription}
        >
          <FqdnCell
            fqdn={fqdn}
            isValid={valid}
            premium={premium}
            corporate={corporate}
            isErrorWithRestriction={isErrorWithRestriction}
            cheapRenew={cheapRenew}
            forceDisplayRestriction={forceDisplayRestriction}
          />
        </Base>
      </>
    </ProvidedContainerLayout>
  );
}
